<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.59883 9.12402L3.13214 10.0218C2.54828 10.2343 2.24725 10.8799 2.45975 11.4638L2.71627 12.1686C2.92877 12.7524 3.57434 13.0534 4.1582 12.8409L6.62489 11.9431"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.5701 6.87939L6.75105 7.90545C5.97258 8.18879 5.5712 9.04955 5.85454 9.82805L6.36757 11.2375C6.65091 12.016 7.51167 12.4174 8.29014 12.1341L11.1092 11.108"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.076 5.53342L14.9523 4.12259C15.3415 3.98091 15.7719 4.1816 15.9135 4.57084L17.4526 8.79943C17.5943 9.18868 17.3936 9.6191 17.0044 9.7607L13.1282 11.1716C12.1551 11.5258 11.0791 11.024 10.725 10.051L9.95538 7.93663C9.60123 6.96354 10.1029 5.88759 11.076 5.53342Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.25 16V12.25"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 16H11.5"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CompetitorResearchIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
